import { constants } from '@thecb/components';
import * as React from 'react';

export const SearchIcon = ({ color = constants.colors.MATISSE_BLUE }) => {
  return (
    <svg
      width={23}
      height={23}
      viewBox="0 0 23 23"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>{'Icons / Small / Search / Search - M 24px'}</title>
      <defs>
        <path
          d="M11.096 1.404a6 6 0 01.924 11.93v6.954a.5.5 0 01-.5.5h-.847a.5.5 0 01-.5-.5v-6.955a6.001 6.001 0 01.923-11.93zm0 1.846a4.154 4.154 0 100 8.308 4.154 4.154 0 000-8.308z"
          id="prefix__a"
        />
      </defs>
      <use
        fill={color}
        transform="rotate(-45 11.45 10.642)"
        xlinkHref="#prefix__a"
        fillRule="evenodd"
      />
    </svg>
  );
};
